<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-5'
    ]"
    alt="Payje logo"
    src="@/assets/image/powered-by-payje-light.svg"
  />
</template>